var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-table",
        _vm._g(
          _vm._b(
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading"
                }
              ],
              ref: "Ytable",
              style: [
                { width: "100%" },
                { fontSize: _vm.fonts ? _vm.fonts : "12px" }
              ],
              attrs: {
                data: _vm.tableDataList,
                border: "",
                size: "mini",
                "default-expand-all": _vm.expendAll,
                lazy: "",
                "row-key": _vm.rowKey,
                "tree-props": {
                  children: "children",
                  hasChildren: "hasChildren"
                },
                "max-height": _vm.maxHeight,
                height: _vm.height,
                "highlight-current-row": "",
                "show-summary": _vm.showSummary,
                "summary-method": _vm.getSummaries,
                "header-cell-class-name": _vm.cellClass,
                "cell-style": _vm.headFirst
              },
              on: {
                "selection-change": _vm.selectionChage,
                select: _vm.handleSelectChange,
                "current-change": _vm.currentChange,
                "row-dblclick": function(row, column, event) {
                  return _vm.rowDbClick(row, column, event)
                },
                "row-click": function(row, column, event) {
                  return _vm.rowClick(row, column, event)
                },
                "sort-change": _vm.sortChange,
                "cell-click": _vm.cellClick,
                "header-dragend": _vm.changeheight,
                "select-all": _vm.selectAllData
              },
              nativeOn: {
                keydown: function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")
                  ) {
                    return null
                  }
                  return _vm.handleTab(_vm.noShowName)
                }
              }
            },
            "el-table",
            _vm.$attrs,
            false
          ),
          _vm.$listeners
        ),
        [
          _c("el-table-column", {
            attrs: {
              selectable: _vm.checkSelect,
              type: "selection",
              width: "60",
              align: "center",
              fixed: "left",
              "reserve-selection": true
            }
          }),
          _vm.index
            ? _c("el-table-column", {
                attrs: {
                  label: _vm.$t("configMoudle.linenum"),
                  type: "index",
                  width: "60",
                  align: "center",
                  fixed: "left",
                  "header-align": "center",
                  sortable: ""
                }
              })
            : _vm._e(),
          _vm._l(_vm.columnList, function(val, index) {
            return _c("el-table-column", {
              key: index,
              attrs: {
                prop: val[_vm.columnKey],
                label: val[_vm.columnLabel],
                resizable: val.resizable || true,
                fixed: val.fixed || val.isLocked,
                align:
                  val[_vm.alingitem] == 1
                    ? "left"
                    : val[_vm.alingitem] == 2
                    ? "center"
                    : val[_vm.alingitem] == 3
                    ? "right"
                    : "left",
                "header-align": "center",
                "min-width":
                  val.width === "auto" ? "" : val.width || val.colWidth || 120,
                sortable: "custom",
                sortable: "",
                "show-overflow-tooltip": val.fieldName != "img_ids"
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "header",
                    fn: function(ref) {
                      var column = ref.column
                      return [
                        _vm._v(" " + _vm._s(column.label) + " "),
                        _vm.headerbe ? _c("br") : _vm._e(),
                        _c(
                          "el-popover",
                          {
                            attrs: {
                              placement: "top",
                              width: "400",
                              trigger: "click"
                            }
                          },
                          [
                            _c("el-input", {
                              attrs: {
                                size: "mini",
                                clearable: "",
                                placeholder: _vm.$t("configMoudle.content")
                              },
                              nativeOn: {
                                keyup: function($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  return _vm.handleSearch(column)
                                }
                              },
                              model: {
                                value: val.inputSearch,
                                callback: function($$v) {
                                  _vm.$set(val, "inputSearch", $$v)
                                },
                                expression: "val.inputSearch"
                              }
                            }),
                            _vm.isColumnFilter
                              ? _c("i", {
                                  staticClass: "el-icon-search",
                                  staticStyle: { cursor: "pointer" },
                                  attrs: { slot: "reference" },
                                  on: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                      return _vm.handleHeaderSearch(
                                        column,
                                        index,
                                        val
                                      )
                                    }
                                  },
                                  slot: "reference"
                                })
                              : _vm._e()
                          ],
                          1
                        ),
                        !val.isReadOnly &&
                        _vm.isBatchModify &&
                        _vm.isEditOutline
                          ? _c("i", {
                              staticClass: "vxe-icon--edit-outline",
                              staticStyle: { cursor: "pointer" },
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  return _vm.handleHeaderEdit(column)
                                }
                              }
                            })
                          : _vm.editCell &&
                            !val.isReadOnly &&
                            _vm.isSchemeEdit &&
                            !(_vm.isBatchModify && _vm.isEditOutline)
                          ? _c("i", {
                              staticClass: "vxe-icon--edit-outline",
                              staticStyle: { cursor: "pointer" },
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  return _vm.handleHeaderBatchEdit(val, column)
                                }
                              }
                            })
                          : _vm._e()
                      ]
                    }
                  },
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        val.jumpMenu
                          ? _c(
                              "span",
                              _vm._l(
                                _vm.splitStr(scope.row[val[_vm.columnKey]]),
                                function(jumpNo) {
                                  return _c(
                                    "span",
                                    {
                                      staticClass: "jump-menu",
                                      on: {
                                        click: function($event) {
                                          return _vm.jumpMenu(
                                            val,
                                            scope.row,
                                            jumpNo
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(jumpNo))]
                                  )
                                }
                              ),
                              0
                            )
                          : (_vm.isEdited &&
                              ((_vm.editCell && !val.isReadOnly) ||
                                (val.isEditableUnderApproval &&
                                  _vm.$route.query.peddingApproval &&
                                  !_vm.tabItemIsReadOnly)) &&
                                val[_vm.columnKey] === _vm.cellColumn &&
                                scope.row.$index === _vm.cellRow) ||
                            (val[_vm.columnKey] === _vm.cellColumn &&
                              scope.row.$index === _vm.cellRow &&
                              _vm.$route.path == "/CW/sdrl_edit")
                          ? _vm._t("myColumn", null, {
                              row: scope.row,
                              column: val,
                              $index: scope.$index
                            })
                          : val.fieldName === "placed"
                          ? _c("div", [
                              scope.row.placed === "-1"
                                ? _c("span", [
                                    _vm._v(_vm._s(_vm.$t("Approval.reject")))
                                  ])
                                : scope.row.placed === "0"
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.$t("feedback.notStarted"))
                                    )
                                  ])
                                : scope.row.placed === "2"
                                ? _c("span", [
                                    _vm._v(_vm._s(_vm.$t("addTips.pass")))
                                  ])
                                : _c("span", [
                                    _vm._v(_vm._s(_vm.$t("addTips.approve")))
                                  ])
                            ])
                          : val.fieldName === "http"
                          ? _c(
                              "div",
                              {
                                staticStyle: {
                                  "text-decoration": "underline",
                                  color: "#551a8b"
                                }
                              },
                              [
                                _c(
                                  "a",
                                  {
                                    attrs: {
                                      href: scope.row[val[_vm.columnKey]],
                                      target: "_Blank"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.handlePreview(scope.row, val)
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm._f("booleanFilter")(
                                            scope.row[val[_vm.columnKey]],
                                            val,
                                            _vm.itemsConfigVOs
                                          )
                                        )
                                    )
                                  ]
                                )
                              ]
                            )
                          : val.fieldName === "real_attach_name"
                          ? _c(
                              "div",
                              {
                                staticStyle: {
                                  "text-decoration": "underline",
                                  color: "#551a8b"
                                }
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticStyle: { cursor: "pointer" },
                                    on: {
                                      click: function($event) {
                                        return _vm.handleFileView(
                                          scope.row,
                                          val
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(scope.row[val[_vm.columnKey]])
                                    )
                                  ]
                                )
                              ]
                            )
                          : val.fieldName === "img_ids" &&
                            Array.isArray(scope.row.img_ids) &&
                            scope.row.img_ids[0] &&
                            scope.row.img_ids[0].url
                          ? _c("el-image", {
                              staticStyle: {
                                height: "100px",
                                width: "100px",
                                "margin-right": "10px"
                              },
                              attrs: {
                                fit: "scale-down",
                                src: scope.row.img_ids[0].url,
                                alt: "",
                                "preview-src-list": [
                                  scope.row.img_ids[0].originUrl
                                ]
                              }
                            })
                          : val.fieldName === "img_ids"
                          ? _c("div", {
                              staticStyle: {
                                height: "100px",
                                width: "100px",
                                "margin-right": "10px"
                              }
                            })
                          : [
                              (_vm.$route.path == "/CW/fksq_view" ||
                                _vm.$route.path == "/CW/sfgl_view" ||
                                _vm.$route.path == "/CW/sfgl_add" ||
                                _vm.$route.path == "/CW/fksq_add" ||
                                _vm.$route.path == "/CW/fksq_edit" ||
                                _vm.$route.path == "/CW/sfgl_edit") &&
                              val.fieldName === "pono"
                                ? _c(
                                    "span",
                                    {
                                      style:
                                        _vm.$route.path == "/CW/fksq_view" ||
                                        _vm.$route.path == "/CW/sfgl_view" ||
                                        _vm.$route.path == "/CW/sfgl_add" ||
                                        _vm.$route.path == "/CW/fksq_add" ||
                                        _vm.$route.path == "/CW/fksq_edit" ||
                                        _vm.$route.path == "/CW/sfgl_edit"
                                          ? "width: 100%;color:blue;text-decoration:underline"
                                          : "width: 100%;"
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm._f("booleanFilter")(
                                              scope.row[val[_vm.columnKey]],
                                              val,
                                              _vm.itemsConfigVOs
                                            )
                                          ) +
                                          " "
                                      )
                                    ]
                                  )
                                : _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            scope.row[val[_vm.columnKey]] ||
                                            scope.row[val[_vm.columnKey]] === 0,
                                          expression:
                                            "scope.row[val[columnKey]] || scope.row[val[columnKey]] === 0"
                                        }
                                      ],
                                      style: scope.row.subtotal
                                        ? "color:red;font-weight:bold;background-color:rgb(192,195,202);width:100%;"
                                        : "width: 100%;"
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm._f("booleanFilter")(
                                              scope.row[val[_vm.columnKey]],
                                              val,
                                              _vm.itemsConfigVOs
                                            )
                                          ) +
                                          " "
                                      )
                                    ]
                                  )
                            ]
                      ]
                    }
                  }
                ],
                null,
                true
              )
            })
          }),
          (this.$route.path !== "/kcgl/kccx" && !_vm.handleDisable) ||
          _vm.cwqrisok
            ? [
                _vm._t("handle", [
                  _c("Y-table-Handle", {
                    attrs: {
                      isExcelExport: _vm.isExcelExport,
                      isExcelImport: _vm.isExcelImport,
                      columnSetting: _vm.columnSetting,
                      headerbr: _vm.headerbe
                    },
                    on: {
                      handleClickHandle: _vm.handleClickHandle,
                      handleExport: _vm.handleExport,
                      handleImport: _vm.handleImport,
                      handleSettings: _vm.handleSettings
                    }
                  })
                ])
              ]
            : _vm._e(),
          _vm.handleDisable &&
          (_vm.handleBtn.length || _vm.$route.query.biaoshi) &&
          !_vm.cwqrisok
            ? [
                _vm._t("handle", [
                  _c("Y-table-Handle", {
                    attrs: {
                      handleDisable: _vm.handleDisable,
                      isExcelExport: _vm.isExcelExport,
                      isExcelImport: _vm.isExcelImport,
                      columnSetting: _vm.columnSetting,
                      headerbr: _vm.headerbe
                    },
                    on: {
                      handleClickHandle: _vm.handleClickHandle,
                      handleExport: _vm.handleExport,
                      handleImport: _vm.handleImport,
                      handleSettings: _vm.handleSettings
                    }
                  })
                ])
              ]
            : _vm._e()
        ],
        2
      ),
      _c(
        "el-dialog",
        {
          staticStyle: { width: "100%" },
          attrs: { visible: _vm.imgdivDialogVisible },
          on: {
            "update:visible": function($event) {
              _vm.imgdivDialogVisible = $event
            }
          }
        },
        [
          _c(
            "div",
            { staticStyle: { margin: "0 auto", "text-align": "center" } },
            [
              _c("img", {
                staticStyle: { width: "500px", height: "auto" },
                attrs: { src: _vm.imgUrl, alt: "" }
              })
            ]
          )
        ]
      ),
      _vm.total
        ? _c(
            "footer",
            { staticStyle: { "text-align": "end", "user-select": "none" } },
            [_vm._v(" " + _vm._s(_vm._total) + " ")]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }